/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { collection, onSnapshot, query, where, getDoc, getDocs } from "firebase/firestore";
import { useFirestore } from "../../firebase/FirestoreContext";
import "../../styles/global.css";
import NavigationSimple from "../../elements/NavigationSimple";
import ListItem from "../../elements/ListItem";
import { borderRadius, display, height, textAlign, width } from "@mui/system";
import { text } from "@fortawesome/fontawesome-svg-core";
import { EnvContext } from "../../context/EnvContext";
import config from "../../config";
import Footer from "../../elements/Footer";
import FeaturedCarousel_MobileV2 from "../../elements/FeaturedCarousel_MobileV2";
import FeaturedCarousel_DesktopV2 from "../../elements/FeaturedCarousel_DesktopV2";
import useWindowSize from "../../utils/useWindowSize";
import getListingsCollection from "../../utils/getListingsCollection";

const CustomCategoryPage = () => {
  const { name } = useParams(); // Get category name from URL
  const db = useFirestore(); // Firestore instance
  // environment
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategory = async () => {
      const categoriesRef = collection(db, `${collectionPath}SooperstockSettings/Categories/DataBase`);
      const q = query(categoriesRef, where("url", "==", name));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const categoryData = querySnapshot.docs[0].data();
        setCategory(categoryData);
        fetchProducts(categoryData.products || []);
      } else {
        setLoading(false);
      }
    };

    const fetchProducts = async (productIds) => {
      if (!productIds.length) {
        setProducts([]);
        setLoading(false);
        return;
      }
      const productsCollectionRef = getListingsCollection(db);
      const productsSnap = await getDocs(productsCollectionRef);
      const allProducts = productsSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const filteredProducts = allProducts.filter((product) => productIds.includes(product.seller_product_id));
      setProducts(filteredProducts);
      setLoading(false);
    };

    fetchCategory();
  }, [db, name, collectionPath]);

  const applyFilters = (filters = {}, searchTerm = "") => {
    console.log("applyFilters called with:", filters, searchTerm);
    // No filtering logic for now, but you can customize this later if needed.
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="category-page" style={{ minHeight: "100vh", display: "flex", flex: 1, flexDirection: "column" }}>
      <NavigationSimple categoryName={category?.name || "N/A"} applyFilters={applyFilters} hideCategories={true} />

      {category?.featuredProductTop && isMobile && <FeaturedCarousel_MobileV2 featuredCollection={`${category?.featuredProductTop.trim().toLowerCase()}`} />}
      {category?.featuredProductTop && !isMobile && <FeaturedCarousel_DesktopV2 featuredCollection={`${category?.featuredProductTop.trim().toLowerCase()}`} />}
      <div style={styles.productGrid}>
        {products.length > 0 ? (
          products.map((product) => <ListItem key={product.id} product={product} displayType={"horisontal"} />)
        ) : (
          <div>No products found for this category.</div>
        )}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  productGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    padding: "0px 0px",
    flex: 1,
    alignContent: "start",
  },
  noProducts: {
    textAlign: "center",
    padding: "50px 0",
    fontSize: "18px",
    opacity: 0.7,
  },
  backButton: {
    height: "50px",
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    alignSelf: "center",
    margin: "5px 0px 0 15px",
    background: "rgba(100,100,100,.07)",
    cursor: "pointer",
    borderRadius: "50%",
    paddingTop: "5px",
  },
};

export default CustomCategoryPage;
